// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUserCheck, IconBasket, IconMessages, 
    IconLayoutKanban, IconMail, IconCalendar, 
    IconNfc,
    IconBook,
    IconUserCircle 
} from "@tabler/icons-react"

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const deliberations = {
    id: 'gestiondeliberations1',
    title: ["G. ", <FormattedMessage id="gestiondeliberations" />],
    type: 'group',
    icon: <IconCalendar />, // Use a valid icon component here
   /*  children: [
     
                {
                    id: "collapse1",
                    title: <FormattedMessage id="collapse" />,
                    type: "collapse",
                    icon: IconUserCircle, */
                    children: [

                        {
                            id: 'configurationPoints1',
                            title: ["1. ", <FormattedMessage id="configurationPoints1" />],
                            type: "item",
                            url: '/formules/DiversConfiguration'
                          },

                          {
                            id: 'creditsValidLMS',
                            title: ["2. ", <FormattedMessage id="creditValid_lmd" />],
                            type: "item",
                            url: '/formules/ldmcreditvalid'
                          },

                          {
                            id: 'config_numero_reprovacoes1',
                            title: ["3. ",<FormattedMessage id="config_numero_reprovacoes" />],
                            type: 'item',
                            url: '/formules/ConfigurationEchecsLegerEtGrave'
                        },
                       
                        {
                            id: 'ficheCotationSession1_1',
                            title: ["4. ", <FormattedMessage id="ficheCotationSession1" />],
                            type: 'item',
                            url: '/grillesFiche/FicheCotationSession1'
                        },
                        
                        {
                            id: 'Pautageralpourcentageentre',
                            title: ["5. ", <FormattedMessage id="pautageral_pourcentage_entre_titre" />],
                            type: 'item',
                            url: '/grillesFiche/PautaGeralPourcentageEntreEnregistrer'
                        },
                        {
                            id: 'deliberation_premiere_session1',
                            title: ["6. ",<FormattedMessage id="deliberation_premiere_session" />],
                            type: 'item',
                            url: '/grillesFiche/DeliberationPremiereSession'
                        },

                        {
                            id: 'deliberation_inscriptions_speciales1',
                            title: ["7. ", <FormattedMessage id="deliberation_inscriptions_speciales" />],
                            type: 'item',
                            url: '/grillesFiche/DeliberationInscriptionSpecial'
                        },

                        {
                            id: 'listecourspointManquantsSesion2_',
                            title: ["8. ", <FormattedMessage id="listecourspointManquantsSesion2" />],
                            type: 'item',
                            url: '/grillesFiche/ListeCoursPointsNonEnregistres'
                        },
                        {
                            id: 'mentions_deliberation1',
                            title: ["9. ", <FormattedMessage id="mentions_deliberation_session1" />],
                            type: 'item',
                            url: '/formules/MentionPourcentage'
                        },
                       
                       
                    ],
              //    },
   // ]
};

export default deliberations;
